<template>
  <div>
    <div class="myPanel">
      <div class="form-group">
        <a role="button" class="btn btn-info myButton" @click="btnGotoScanCode">社員報到掃描</a>
        <small class="form-text text-muted"></small>
      </div>
<!--      <div class="form-group">-->
<!--        <a role="button" class="btn btn-primary myButton" @click="btnGotoScanCodeManual">社員報到 手動</a>-->
<!--        <small class="form-text text-muted"></small>-->
<!--      </div>-->

<!--      <div class="form-group">-->
<!--        <a role="button" class="btn btn-info myButton" @click="btnGotoEventMag">活動管理</a>-->
<!--        <small class="form-text text-muted"></small>-->
<!--      </div>-->
<!--      <div class="form-group">-->
<!--        <a role="button" class="btn btn-info myButton" @click="btnGotoGame">抽獎</a>-->
<!--        <small class="form-text text-muted"></small>-->
<!--      </div>-->


    </div>
  </div>
</template>

<script>
/**

 **/


export default {
  //name: "index",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
    };
  },
  methods: {
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
    btnGotoScanCode(){
      this.$router.push({ name: 'CheckInAdminScanCodeEventItemsSelector'})
    },
    // dlgEventItemsReturnSelect(item){
    //   this.$router.push({ name: 'CheckInAdminScanCode', query: { EventSystemId: item.SystemId }})
    // },

    btnGotoScanCodeManual(){

    },
    // btnGotoEventMag(){
    //   this.$router.push({ name: 'CheckInAdminEventIndex', query: { ID: 0 }})
    // },
    // btnGotoGame(){
    //   this.$router.push({ name: 'CheckInAdminGame', query: { ID: 0 }})
    // },
  },
  mounted() {
    //this.loadData()
  },
}
</script>

<style scoped>
.myPanel{
  max-width:500px;
  margin:0 auto;
}

.myButton{
  width:300px;
  color:white;
}
</style>
